import { Check } from "lucide-react";
import { useState } from "react";
import type { CargoCellSize } from "../objects/standard-rack-shelf";

type RackShelfCellSizeControlsProps = {
  disabled?: boolean;
  initialValue: CargoCellSize;
  onApply: (cargoCellSize: CargoCellSize) => Promise<void>;
};

type CargoCellSizeDraft = Record<keyof CargoCellSize, string>;

const cargoCellSizeFields: Array<{ key: keyof CargoCellSize; label: string }> = [
  { key: "length", label: "长" },
  { key: "width", label: "宽" },
  { key: "height", label: "高" }
];

export function RackShelfCellSizeControls({
  disabled = false,
  initialValue,
  onApply
}: RackShelfCellSizeControlsProps) {
  const [draft, setDraft] = useState<CargoCellSizeDraft>({
    height: String(initialValue.height),
    length: String(initialValue.length),
    width: String(initialValue.width)
  });
  const cargoCellSize = parseCargoCellSize(draft);

  return (
    <form
      className="rack-shelf-cell-size-controls"
      onSubmit={(event) => {
        event.preventDefault();

        if (cargoCellSize) {
          void onApply(cargoCellSize);
        }
      }}
    >
      <div className="rack-shelf-cell-size-title">货仓尺寸</div>
      <div className="rack-shelf-cell-size-fields">
        {cargoCellSizeFields.map(({ key, label }) => (
          <label className="rack-shelf-cell-size-field" key={key}>
            <span>{label}</span>
            <div className="rack-shelf-cell-size-input-wrap">
              <input
                disabled={disabled}
                inputMode="decimal"
                min="0.01"
                onChange={(event) => {
                  setDraft((currentDraft) => ({
                    ...currentDraft,
                    [key]: event.target.value
                  }));
                }}
                step="0.01"
                type="number"
                value={draft[key]}
              />
              <span>m</span>
            </div>
          </label>
        ))}
      </div>
      <button disabled={disabled || !cargoCellSize} type="submit">
        <Check aria-hidden="true" size={16} strokeWidth={2} />
        应用
      </button>
    </form>
  );
}

function parseCargoCellSize(draft: CargoCellSizeDraft) {
  const cargoCellSize: CargoCellSize = {
    height: Number(draft.height),
    length: Number(draft.length),
    width: Number(draft.width)
  };

  if (Object.values(cargoCellSize).some((value) => !Number.isFinite(value) || value <= 0)) {
    return undefined;
  }

  return cargoCellSize;
}
